
import { defineComponent } from 'vue'
import { iFunction } from './FunctionsCatalog'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import functionsCatalogDatatableDescriptor from './FunctionsCatalogDatatableDescriptor.json'

export default defineComponent({
    name: 'functions-catalog-datatable',
    components: { Column, DataTable },
    props: {
        user: { type: Object },
        propLoading: { type: Boolean },
        items: { type: Array }
    },
    emits: ['selected', 'preview', 'deleted'],
    data() {
        return {
            functionsCatalogDatatableDescriptor,
            functions: [] as iFunction[],
            filteredFunctions: [] as iFunction[],
            searchWord: '',
            loading: false
        }
    },
    watch: {
        propLoading() {
            this.setLoading()
        },
        items() {
            this.loadFunctions()
        }
    },
    computed: {
        canManageFunctionalities(): boolean {
            const index = this.user?.functionalities?.findIndex((el: string) => el === 'FunctionsCatalogManagement')
            return index !== -1
        }
    },
    async created() {
        this.setLoading()
        this.loadFunctions()
    },
    methods: {
        setLoading() {
            this.loading = this.propLoading
        },
        loadFunctions() {
            this.functions = [...(this.items as iFunction[])]
            this.filteredFunctions = [...this.functions]
            this.searchWord = ''
        },
        previewFunction(tempFunction: iFunction) {
            this.$emit('preview', tempFunction)
        },
        canDelete(tempFunction: iFunction) {
            return this.canManageFunctionalities || tempFunction?.owner === this.user?.userId
        },
        deleteFunctionConfirm(functionId: string) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.$emit('deleted', functionId)
            })
        },
        searchFunctions() {
            setTimeout(() => {
                if (!this.searchWord.trim().length) {
                    this.filteredFunctions = [...this.functions] as any[]
                } else {
                    this.filteredFunctions = this.functions.filter((tempFunction: any) => {
                        return (
                            tempFunction.label.toLowerCase().includes(this.searchWord.toLowerCase()) ||
                            tempFunction.name.toLowerCase().includes(this.searchWord.toLowerCase()) ||
                            tempFunction.type.toLowerCase().includes(this.searchWord.toLowerCase()) ||
                            tempFunction.language.toLowerCase().includes(this.searchWord.toLowerCase()) ||
                            tempFunction.owner.toLowerCase().includes(this.searchWord.toLowerCase()) ||
                            (tempFunction.tags && tempFunction.tags.includes(this.searchWord.toLowerCase()))
                        )
                    })
                }
            }, 250)
        }
    }
})
